import React, { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_MSG = "Join thousands of people building a healthier, smarter life.";

const FAKE_NAMES = [
  "Sarah", "Marcus", "Priya", "James", "Emma", "Alex", "Olivia",
  "Daniel", "Sophia", "Liam", "Maya", "Noah", "Ava", "Ethan",
  "Isabella", "Jordan", "Chloe", "Aiden", "Zara", "Lucas",
];

const pickRandom = (arr, exclude) => {
  let pick = arr[Math.floor(Math.random() * arr.length)];
  let safety = 5;
  while (pick === exclude && safety-- > 0) {
    pick = arr[Math.floor(Math.random() * arr.length)];
  }
  return pick;
};

/**
 * Rotates between:
 *   - "{Name} just joined Prosper.AI" (random fake names + real latest signup when available)
 *   - The default "Join thousands of people..." message
 * Bumping `refreshKey` re-fetches the latest signup immediately.
 */
export const SocialProofFlash = ({ refreshKey = 0 }) => {
  const [latestName, setLatestName] = useState(null);
  const [phase, setPhase] = useState("name"); // "name" | "default"
  const [currentName, setCurrentName] = useState(pickRandom(FAKE_NAMES));
  const [visible, setVisible] = useState(true);

  // Fetch latest signup
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/signups/latest`);
        if (mounted) setLatestName(res?.data?.name || null);
      } catch (_e) {
        if (mounted) setLatestName(null);
      }
    })();
    return () => { mounted = false; };
  }, [refreshKey]);

  // Rotate every 3.5s with fade
  useEffect(() => {
    const id = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setPhase((p) => {
          if (p === "name") return "default";
          // moving back to name phase — pick a fresh name (sometimes real latest, mostly fake)
          const useReal = latestName && Math.random() < 0.35;
          setCurrentName(useReal ? latestName : pickRandom(FAKE_NAMES, currentName));
          return "name";
        });
        setVisible(true);
      }, 280);
    }, 3500);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestName, currentName]);

  return (
    <p
      data-testid="social-proof-flash"
      className={`text-sm text-slate-500 leading-snug transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      {phase === "name" ? (
        <>
          <span className="font-semibold text-[#0FB5A6]">{currentName}</span>
          <span> just joined Prosper.AI </span>
          <span className="inline-block h-2 w-2 rounded-full bg-emerald-400 align-middle animate-pulse" />
        </>
      ) : (
        DEFAULT_MSG
      )}
    </p>
  );
};

export default SocialProofFlash;
